import { render, staticRenderFns } from "./FAQHeading.vue?vue&type=template&id=b5d9d362&"
import script from "./FAQHeading.vue?vue&type=script&lang=js&"
export * from "./FAQHeading.vue?vue&type=script&lang=js&"
import style0 from "./FAQHeading.vue?vue&type=style&index=0&id=b5d9d362&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports